export const SHOW_RATES = String(process.env.REACT_APP_SHOW_RATES).toLowerCase() === "true";